import '../css/app.css';
import $ from 'jquery';
import 'slick-carousel';
import 'jquery-match-height';
import { run as lightBox } from 'baguettebox.js';
import 'picturefill';

$(() => {
  // Menu Toggle
  $('.header-burger-menu').on('click', function(){
    $('body').toggleClass('no-scroll');
    $(this).toggleClass('open');
    $('.header-links').slideToggle();
  });

  // Home Testimonials Slider
  $('.testimonial-slider').slick({
    // normal options...
    infinite: true,
    slidesToShow: 1,
    arrows: true,
    dots: false
  });

  $('.testimonial-inner').matchHeight();

  // Pagination Arrows
  $('.pagination li:first-of-type span').html('');
  $('.pagination li:first-of-type a').html('');
  $('.pagination li:last-of-type span').html('');
  $('.pagination li:last-of-type a').html('');

  // Light box overlay for images
  lightBox('.lightbox', {
    animation: 'fadeIn',
    noScrollbars: true,
    buttons: true,
    captions: function(element) {
      return element.getElementsByTagName('img')[0].alt;
    },
    titleTag: true
  });

  picturefill();
});



// WEBPACK FOOTER //
// ./assets/js/app.js